import Model from './Model'
import ImageContainer from '../Images/ImageContainer'
import FontDefinition from '../Fonts/FontDefinition'
import RGBA from '../Fonts/RGBA'
import game from '../Game/GameInstance'
import gsap from 'gsap';
import colorSchemeRepository from '../Images/ColorSchemeRepository'
import UrlExecutor from "../Api/UrlExecutor";

let maxInteractingPeopleInLobby = 15;

export default class Person extends Model {

  constructor(data, size, game) {

    size = (size ? size : 40);

    let width = size + 4;
    let height = size + 4;

    super(width, height, data);

    this.id = data.id;

    this.canvas.width = width;
    this.canvas.height = height;
    this.ctx.width = width;
    this.ctx.height = height;

    let minSpeed = .8;
    let maxSpeed = 1.2;
    this.speed = (Math.random() * (maxSpeed - minSpeed)) + minSpeed;

    this.size = size;
    this.game = game;

    this.center.x = width / 2;
    this.center.y = height / 2;

    this.inRoom = true;
    this.room = null;

    this.dest = false;
    this.nextDest = false;
    this.point = false;
    this.lobbyState = {
      mustWait: false,
      waiting: false,
      talkInvitation: null,
      exiting: false,
      openForTalking: true
    };

    this.zIndex = 0;
    this.imageObject = null;

    this.gsap = null;

    if (this.data.image_url) {
      this.imageObject = ImageContainer.getInstance().image(this.data.image_url);

      this.imageObject.load().then((image) => {
        this.needsRendering = true;
      });
    }

  }

  setZIndex(index) {
    if (index !== this.zIndex) {
      this.zIndex = index;
      game.layers.people.needsSort = true;
    }
  }

  getFontSize() {
    return this.size > 40 ? 28 : 16;
  }

  draw(ctx) {

    ctx.beginPath();
    ctx.arc(this.scale(this.width / 2), this.scale(this.width / 2), this.scale(this.size / 2), 0, Math.PI * 2);

    let borderSize = 2;
    if (this.size > 40) {
      borderSize = 4;
    }
    ctx.lineWidth = this.scale(borderSize);

    ctx.strokeStyle = colorSchemeRepository.get('foregroundText');
    ctx.fillStyle = colorSchemeRepository.get('personBackground');
    ctx.fill();
    ctx.stroke();


    if (this.imageObject) {

      let imageX = 0;
      let imageY = 0;
      let imageWidth = 0;
      let imageHeight = 0;

      if (this.imageObject.getImage().width > this.imageObject.getImage().height) {
        // horizontal image
        imageHeight = this.size;
        imageWidth = this.size * (this.imageObject.getImage().width / this.imageObject.getImage().height);
      }
      else {
        imageWidth = this.size;
        imageHeight = this.size * (this.imageObject.getImage().height / this.imageObject.getImage().width);
      }

      imageX = (this.size - imageWidth) / 2;
      imageY = (this.size - imageHeight) / 2;

      ctx.clip();
      try {
        ctx.drawImage(this.imageObject.getImage(), this.scale(imageX), this.scale(imageY ), this.scale(imageWidth )+ 2, this.scale(imageHeight) + 2);
      } catch (e) {
        console.warn(e);
      }
      ctx.restore();


      return;
    }

    ctx.stroke();
    ctx.fill();

    let text = this.getInitials();
    ctx.font = (new FontDefinition('Roboto')).size(this.scale(this.getFontSize()));

    ctx.fillStyle = colorSchemeRepository.get('foregroundText');
    let size = ctx.measureText(text);
    ctx.fillText(text, (this.scale(this.getWidth()) - size.width) / 2, this.scale(this.height + this.getFontSize()) / 2.2);


  }

  animateToRoom(room_id) {
    return this.moveToRoom(room_id, true);
  }

  setPoint(point) {

    this.point = point;
    this.x = this.point.x;
    this.y = this.point.y;
    this.needsPositioning = true;

  }

  setRoom(room, firstMove) {

    if (room === null || room === undefined) {
      this.point = this.game.entrancePoint;
      this.room = null;
      this.hide('In exit');
      return;

    }

    this.point = room.getDoorPoint();

    this.x = this.point.x;
    this.y = this.point.y;
    this.room = room;
    this.room.addPerson(this, firstMove);

  }

  moveToRoom(room) {
    if ((room === undefined || room === null) && this.dest === false && this.room === null) {
      this.x = -10000
      this.y = -10000
      return
    }


    if (room === this.dest || room === this.room) {
      return;
    }

    // room can either be a Room object, or NULL if moving towards the exit.
    let fromPoint = null;
    let toPoint = null;

    // if we're currently in an animation, wait for it to finish and then move
    if (this.dest !== false || (this.room && this.room.data.mode === 'lobby')) {
      this.nextDest = room;
      return;
    }

    // find out what our destination point must be

    toPoint = room === null || room === undefined ? this.game.entrancePoint : room.getDoorPoint();

    if(toPoint === null) {
      return;
    }

    fromPoint = this.point;

    // console.log(room, toPoint);

    // if currently in a room, leave it.
    if (this.room) {

      fromPoint = this.room.getDoorPoint();

      if (fromPoint !== toPoint) {
        this.room.removePerson(this);
        this.room = null;
      }

    }

    // if we do not have a current point, assume this is our first move
    if (fromPoint === false) {

      // console.log('Frompoint === false, first move?');
      this.room = room;
      if (room) {
        this.game.updatePersonIndicator(1);
        this.setRoom(room, true);
        return;
      }
      this.setPoint(toPoint);
      return;

    }

    if (this.room && this.room.constructor.name === 'ChildRoom') {
      if (room.constructor.name === 'ChildRoom') {

        this.room.removePerson(this);
        this.setRoom(room);

        return;
      }
    }

    // console.log('Defining dest: ' + room.data.name);

    // define our destination, this says "hey, I'm animating, leave me alone!"
    this.dest = room;

    // now that we have a from and a to point, let's animate this shit

    if (fromPoint !== toPoint) {

      if (fromPoint === this.game.entrancePoint) {
        this.game.updatePersonIndicator(1);
      }

      let path = this.game.shortestPathGenerator.generate(fromPoint, toPoint);
      this.x = fromPoint.x;
      this.y = fromPoint.y;

      this.show();

      this.game.animatePerson(this, path).then(() => {

        // don't do anything if game is paused
        if (this.game.paused) {
          return;
        }

        // animation is done.
        let room = this.dest;

        if (room === null) {
          this.game.updatePersonIndicator(-1);
        }

        // we no longer have a destination
        this.dest = false;
        this.setPoint(toPoint);


        // do we have a next destination?
        if (this.nextDest && this.nextDest.room !== room) {
          let dest = this.nextDest;
          // console.log(dest);
          this.nextDest = false;
          this.moveToRoom(dest);
          return;
        }

        this.nextDest = false;

        this.setRoom(room);

      });

      return;

    }


    this.dest = this.nextDest;
    this.nextDest = false;
    if (this.dest !== false) {
      this.moveToRoom(this.dest);
    }



  }

  getFirstName() {
    return this.data.first_name;
  }

  getLastName() {
    return this.data.last_name;
  }

  getName() {

    if (this.data.first_name && this.data.last_name) {
      return this.data.first_name + ' ' + this.data.last_name;
    }

    if (this.data.first_name) {
      return this.data.first_name;
    }

    return this.data.last_name;

  }

  getInitials() {

    let cap = (str) => {

      if (!str) {
        return '';
      }

      str = str.toUpperCase();
      if (str.substring(0, 2) === 'IJ') {
        return 'IJ';
      }

      return str[0];

    }

    return cap(this.getFirstName()) + cap(this.getLastName());


  }

  startLobbyInteraction(room, firstMove) {

    this.x = room.getDoorPoint().x;
    this.y = room.getDoorPoint().y;

    this.lobbyState.waiting = false;
    this.lobbyState.exiting = false;
    this.lobbyState.talkInvitation = null;
    this.lobbyState.openForTalking = false;

    this.nextLobbyInteraction(room, firstMove);

  }

  nextLobbyInteraction(room, firstMove) {

    let padding = 50;

    // don't do anything if game is paused
    if (game.paused) {
      return;
    }

    // in speaker mode we hold all animations and wait for further instructions
    if (game.view === 'speakers') {
      setTimeout(() => {
        this.nextLobbyInteraction(room);
      }, 100);

      return;
    }



    // first, check if we need to leave the room.
    if (this.nextDest) {

      if (this.nextDest !== room) {
        // if we do, cancel all talk invitations and move directly to doorpoint
        this.lobbyState.talkInvitation = null;
        this.lobbyState.exiting = true;
        this.moveToExit(room);
        return;
      }
      this.nextDest = null;

    }

    // if we do not, check if we should be waiting
    let index = room.people.indexOf(this);
    if (index > maxInteractingPeopleInLobby) {

      // we should be waiting
      if (this.lobbyState.waiting) {

        setTimeout(() => {
          this.nextLobbyInteraction(room);
        }, 2500);

        return;
      }


      let x = room.x + this.size;
      let y = room.y + room.height - this.size;

      this.lobbyMove(x, this.y).then(() => {
        this.lobbyMove(x, y).then(() => {

          if(this.game.paused){
            return
          }
          this.lobbyState.waiting = true;

          this.hide('Waiting in lobby');
          room.hoverMask.findInRegister('person-' + this.id).disable();

          // only when not on the list yet
          if (room.waiters.indexOf(this) === -1) {
            room.waiters.push(this);
            room.updateWaiterCount();
          }

          setTimeout(() => {
            this.nextLobbyInteraction(room);
          }, 2500 + Math.floor(Math.random() * 5000));
        });
      });

      return;

    }

    if (this.lobbyState.waiting) {
      this.lobbyState.waiting = false;
      // remove from waiting list
      let index = room.waiters.indexOf(this);
      if (index !== -1) {
        room.waiters.splice(index, 1);
        room.updateWaiterCount();
      }

    }

    this.show();

    // if we do not, check if we have a talk invitation
    if (this.lobbyState.talkInvitation) {

      let angle = Math.atan2(( this.y - this.lobbyState.talkInvitation.location.y), ( this.x - this.lobbyState.talkInvitation.location.x));
      let x = this.lobbyState.talkInvitation.location.x + Math.cos(angle) * 50;
      let y = this.lobbyState.talkInvitation.location.y + Math.sin(angle) * 50;

      let time = this.lobbyState.talkInvitation.time;

      this.lobbyMove(x, y).then(() => {

        setTimeout(() => {
          this.lobbyState.talkInvitation = null;
          this.nextLobbyInteraction(room);
          setTimeout(() => {
            this.lobbyState.openForTalking = true;
          }, 1500);

        }, 4000 + time);

      });
      return;

    }

    let x = (room.width - padding * 2) * Math.random() + room.x + padding;
    let y = (room.height - padding * 2) * Math.random() + room.y + padding;

    if (firstMove) {
      this.x = x;
      this.y = y;
      setTimeout(() => {
        this.nextLobbyInteraction(room);
      }, 500);
      return;
    }


    if (Math.random() < .1 && this.lobbyState.openForTalking) {
      let person = this.findSomeoneToTalkTo(room);
      if (person) {

        this.lobbyState.openForTalking = false;
        person.lobbyState.openForTalking = false;

        person.lobbyState.talkInvitation = {
          location : {
            x: this.x,
            y: this.y
          },
          time : Math.floor(Math.random() * 5000),
        };

        // wait for other person to arrive and them break up.
        setTimeout(() => {
          this.nextLobbyInteraction(room);

          setTimeout(() => {
            this.lobbyState.openForTalking = true;
          }, 1500);


        }, 7500 + person.lobbyState.talkInvitation.time);

        return;

      }
    }


    // if we do not, roam randomly.
    this.lobbyMove(x, y).then(() => {
      this.lobbyState.openForTalking = true;
      this.nextLobbyInteraction(room);
    });
  }

  lobbyMove(x,y) {

    let duration = Math.sqrt(Math.pow(this.x - x, 2) + Math.pow(this.y - y, 2)) / 200;
    this.gsap =  gsap.to(this, { x, y, duration, ease: 'none', onUpdate: () => this.updateHoverMask(this.x, this.y)});

    return this.gsap;
  }

  updateHoverMask(x, y) {
    const position = {
      x: x - this.room.x - this.center.x,
      y: y - this.room.y - this.center.y
    };

    const size = this.size * 1.5;

    this.room.hoverMask.add('person-' + this.id, position.x, position.y, size, size)
      .enable()
      .over(() => {
        this.gsap.pause();
        game.setToolTipText(this.room.x + position.x + this.size / 2, this.room.y + position.y + this.size, this.getName(), false);
      })
      .out(() => {
        this.gsap.play();
        game.setToolTipText(null);
      })
      .click(() => {
        UrlExecutor.execute(this.data.url);
      });
  }

  moveToExit(room) {

    if(this.game.paused || this.game.view === 'speakers'){
      return;
    }

    if (this.lobbyState.waiting) {
      // remove from waiting list
      this.lobbyState.waiting = false;
      let index = room.waiters.indexOf(this);
      if (index !== -1) {
        room.waiters.splice(index, 1);
        room.updateWaiterCount();
      }
      this.show();
    }

    let x = room.getDoorPoint().x;
    let y = room.getDoorPoint().y;

    this.lobbyMove(x + this.size, y).then(() => {
      this.lobbyMove(x, y).then(() => {

        if(this.game.paused){
          return;
        }
        room.removePerson(this);

        let dest = this.nextDest;
        this.nextDest = false;
        this.room = null;

        room.hoverMask.findInRegister('person-' + this.id).disable();

        this.moveToRoom(dest);

      });
    });

  }

  findSomeoneToTalkTo(room)
  {

    let max = room.people.length;
    if (max < 3) {
      return null;
    }

    if (max > maxInteractingPeopleInLobby) {
      max = maxInteractingPeopleInLobby;
    }

    let iterations = 4;
    do {

      let person = room.people[Math.floor(max * Math.random())];

      // cannot talk to myself, that would be awkward
      if (person !== this) {
        // cannot talk to someone who is already in a conversation, that would be annoying
        if (!person.lobbyState.talkInvitation) {
          if (person.lobbyState.openForTalking) {
            if (!person.lobbyState.exiting) {
              return person;
            }
          }
        }
      }

    }
    while(iterations-- > 0);

    return null;


  }
}
